import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@mui/material';

interface PopupConfirmProps {
  message: string;
  onConfirm?: () => void;
  onClose?: () => void;
}

const PopupConfirm: React.FC<PopupConfirmProps> = ({ message, onConfirm, onClose }) => {
  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Message</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {onClose && (
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
        )}
        {onConfirm && (
          <Button onClick={onConfirm} color="primary" autoFocus>
            Confirm
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PopupConfirm;
